import { render, staticRenderFns } from "./GroupAddressEditor.vue?vue&type=template&id=5efd1ad4&lang=pug&"
import script from "./GroupAddressEditor.vue?vue&type=script&lang=ts&"
export * from "./GroupAddressEditor.vue?vue&type=script&lang=ts&"
import style0 from "./GroupAddressEditor.vue?vue&type=style&index=0&id=5efd1ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports